import { Injectable } from '@angular/core';
import {Offer} from '../../model/offer/offer';
/**
 * Service to transfer an offer between components without using route parameters or state management.
 *
 * It is mainly used in the rendering of the offer preview flow, starting from the setter in the creation offer component and the getter in the preview component.
 * The _basedOnOfferId is used to indicate if the offer is created based on another offer (refilling).
 * */

@Injectable({ providedIn: 'root' })
export class OfferTransferService {
  private _offer: Offer | null = null;
  private _basedOnOfferId: string | null = null;

  set offer(offer: Offer) {
    this._offer = offer;
  }

  get offer(): Offer | null {
    return this._offer;
  }

  set basedOnOfferId(id: string | null) {
    this._basedOnOfferId = id;
  }

  get basedOnOfferId(): string | null {
    return this._basedOnOfferId;
  }

  clear() {
    this._offer = null;
    this._basedOnOfferId = null;
  }
}
